<template>
  <aside v-show="isAsideVisible" class="aside is-placed-left is-expanded">
    <aside-tools :is-main-menu="true">
      <span slot="label" class="logo">
        <router-link to="/" class=" is-small is-info is-action-text">
          <img v-bind:src="productLogo" class="img-rectangle" />
        </router-link>
      </span>
    </aside-tools>
    <div class="menu is-menu-main">
      <template v-for="(menuGroup, index) in menu">
        <p class="menu-label" v-if="typeof menuGroup === 'string'" :key="index">
          {{ menuGroup }}
        </p>
        <aside-menu-list
          v-else
          :key="index"
          @menu-click="menuClick"
          :menu="menuGroup"
        />
      </template>
    </div>
    <div class="asidemenu-footer">
      <span
        >V. {{ appVersion }}<br />
        &copy; {{ new Date().getFullYear() }} Landbell Group</span
      >
    </div>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import AsideTools from "@/components/AsideTools";
import AsideMenuList from "@/components/AsideMenuList";
import { version } from "../../package";
// @group General
export default {
  name: "AsideMenu",
  components: { AsideMenuList, AsideTools },
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      appVersion: version,
      productLogo: require("@/assets/circul8-blue.svg")
    };
  },
  computed: {
    ...mapState(["isAsideVisible"])
  },
  methods: {
    menuClick(item) {
      this.$emit("menu-click", item);
    }
  }
};
</script>
